import { Action, createReducer, on } from '@ngrx/store';
import { SelfPublishTag } from 'src/app/modules/companies/companies.interface';
import * as TagsActions from './tags.actions';

export const tagsFeatureKey = 'tags';

export interface TagsState {
  tags: SelfPublishTag[];
}

export interface TagsStore {
  tags: TagsState;
}

export const initialState: TagsState = {
  tags: null
};

const tagsReducer = createReducer(
  initialState,
  on(TagsActions.setTags, (state, { tags }) => ({ ...state, tags })),
  on(TagsActions.addTag, (state, { tag }) => ({ ...state, tags: [...state.tags, tag] })),
  on(TagsActions.deleteTag, (state, { id }) => {
    const index = state.tags.findIndex((_: SelfPublishTag) => _.id === id);
    return { ...state, tags: [...state.tags.slice(0, index), ...state.tags.slice(index + 1)] };
  })
);

export function reducer(state: TagsState | undefined, action: Action) {
  return tagsReducer(state, action);
}
